import ContentEditableComponent from './ContentEditableComponent';
export default ContentEditableComponent;